// extracted by mini-css-extract-plugin
export default {"newPassInputs":"_1C-0E","passwordFormControl":"yonuR","passwordInput":"_385jb"};